
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class TagModel extends Model<TagModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'tag', type: 'string', languageString: 'tagModel.property.tag' }
	];
	[key: string]: any;
	
	public tag: string;
    
	constructor(){
		super();
		this.tag = '';
		
	}
	getProperties(){
		return TagModel.classProperties;
	}
}

